import React from 'react'
import './styles.scss'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

// eslint-disable-next-line react/display-name
export default (props) => {
  const { id, label, classNameWrapper, startDate, startDateId, endDate, endDateId, minDate, anchorDirection='right', openDirection='down', appendToBody=false } = props
  const [focused, setFocused] = React.useState(null)

  return (
    <div className={`select-date-wrapper ${classNameWrapper}`}>
      <div className='select-date-wrapper-inner'>
        {label && <label htmlFor={id}>{label}</label>}
        <DateRangePicker
          showClearDates
          key={id}
          startDate={startDate}
          startDateId={startDateId}
          endDate={endDate && moment(endDate)}
          endDateId={endDateId}
          onDatesChange={({ startDate, endDate }) => props.onDatesChange(id, startDate, endDate)}
          focusedInput={focused}
          onFocusChange={(focusedInput) => setFocused(focusedInput)}
          hideKeyboardShortcutsPanel={true}
          startDatePlaceholderText={I18n.t('dashboard_from')}
          endDatePlaceholderText={I18n.t('dashboard_until')}
          isOutsideRange={(date) => date.isBefore(moment(minDate || '01/01/1900'))}
          anchorDirection={anchorDirection}
          openDirection={openDirection}
          appendToBody={appendToBody}
          customInputIcon={
            <svg height='20' width='20' viewBox='0 0 20 20' aria-hidden='true' focusable='false' className='arrow-down css-6q0nyr-Svg'>
              <path d='M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z'></path>
            </svg>
          }
        ></DateRangePicker>
      </div>
    </div>
  )
}
